export default __webpack_public_path__ + "static/media/sb-icon.516e637e.webp";